// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const QuoteLink: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 1.87866C19.4374 1.87866 18.8978 2.10216 18.5 2.49998L9 12L8 16L12 15L21.5 5.49998C21.8978 5.10216 22.1213 4.56259 22.1213 3.99998C22.1213 3.43737 21.8978 2.89781 21.5 2.49998C21.1022 2.10216 20.5626 1.87866 20 1.87866Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const QuoteLinkOffset: IconOffset = {
    vertical: 12,
    horizontal: 18,
};

export default React.memo(QuoteLink);
